import { Dropdown, DropdownDivider, DropdownItem, Tooltip } from "nectar-ui";
import React, { useCallback, useState } from "react";
import ReactOutsideClickHandler from "react-outside-click-handler";
import {
  DASHBOARD_RANGE_TYPES_DICTIONARY,
  DASHBOARD_RANGE_TYPE_KEYS,
  DATE_RANGE_DEFAULT_HISTOGRAM_INTERVAL_TOOLTIP_TEXT,
  DATE_RANGE_DEFAULT_HISTOGRAM_KEY_TYPES,
} from "../../../utils/constants/dashboard/dashboardModuleConstants";
import DashboardFilterButton from "../../DashboardFilterButton";
import DashboardChartRangeDatePicker from "./DashboardChartRangeDatePicker";
import { getRangeLabel } from "./helper";

interface Props {
  allowedRangeTypes: Array<DASHBOARD_RANGE_TYPE_KEYS>;
  selectedRange:
    | { fromDate: moment.Moment; toDate: moment.Moment }
    | keyof typeof DASHBOARD_RANGE_TYPES_DICTIONARY;
  setRangeFunction: (rangeType: string) => void;
  hasDatePicker?: boolean;
  enableTooltip?: boolean;
}

const DashboardChartRangeFilter = ({
  allowedRangeTypes,
  selectedRange,
  setRangeFunction,
  hasDatePicker = false,
  enableTooltip = false,
}: Props) => {
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);

  const toggleDatePicker = () => {
    setDatePickerOpen((current) => !current);
  };

  const rangeDropdownOptions = useCallback(() => {
    const defaultRangeOptions = allowedRangeTypes.map((rangeType) => {
      const ItemComponent = () => (
        <DropdownItem key={rangeType} onClick={() => setRangeFunction(rangeType)}>
          {DASHBOARD_RANGE_TYPES_DICTIONARY[rangeType].label}
        </DropdownItem>
      );

      return enableTooltip ? (
        <Tooltip
          placement="right"
          title={
            DATE_RANGE_DEFAULT_HISTOGRAM_INTERVAL_TOOLTIP_TEXT[
              rangeType as DATE_RANGE_DEFAULT_HISTOGRAM_KEY_TYPES
            ]
          }
          offset="30, 0"
        >
          <ItemComponent />
        </Tooltip>
      ) : (
        <ItemComponent />
      );
    });

    if (hasDatePicker) {
      defaultRangeOptions.push(<DropdownDivider />);
      defaultRangeOptions.push(
        <DropdownItem key="datePicker" onClick={toggleDatePicker}>
          Definir periodo
        </DropdownItem>
      );
    }

    return defaultRangeOptions;
  }, [hasDatePicker, allowedRangeTypes, setRangeFunction]);

  const handleApplyDate = (dateRange: string) => {
    toggleDatePicker();
    setRangeFunction(dateRange);
  };

  return (
    <div style={{ position: "relative" }}>
      <Dropdown
        position="left"
        action={<DashboardFilterButton>{getRangeLabel(selectedRange)}</DashboardFilterButton>}
        options={rangeDropdownOptions()}
      />
      {isDatePickerOpen && (
        <ReactOutsideClickHandler onOutsideClick={toggleDatePicker}>
          <DashboardChartRangeDatePicker
            closeDatePicker={toggleDatePicker}
            isOpen={isDatePickerOpen}
            applyDate={handleApplyDate}
          />
        </ReactOutsideClickHandler>
      )}
    </div>
  );
};

export default DashboardChartRangeFilter;
